import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function GenitoreRoute({ children }) {
  const { user } = useAuth();

  if (!user || !user.accessToken) {
    return <Navigate to="/login" replace />;
  }

  if (user.ruolo !== "ROLE_GENITORE") {
    if (user.ruolo === "ROLE_ADMIN") return <Navigate to="/gestionale" replace />;
    if (user.ruolo === "ROLE_STAFF") return <Navigate to="/gestionale1" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}
